import React, {Component} from 'react'

import userPlusIcon from "manager/../images/user-plus.svg"
import styled from "styled-components"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"
import {createStructuredSelector} from "reselect"
import {connect} from "react-redux"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"
import {selectAgentOpId, selectTransactionOpId} from "manager/selectors/referral_selectors"
import {segmentEventTracker} from "common/analytics"
import {
  SettlementButton,
  TextButtonContainer,
  TextContainer
} from "manager/views/components/Settlement/Common/TextButton"

const InviteProviderContainer = styled(SettlementCard)`
  display: flex;
  flex-direction: row;
`
const UserPlusIcon = styled.div`
  margin-top: 30.43px;
  margin-right: 7px;
  background-image: url(${userPlusIcon});
  height: 17px;
  width: 22px;
  flex: 0 0 22px;
  background-size: cover;
`
const HeaderDiv = styled.div`
  color: #545454;
  font-size: 20px;
  font-weight: bold;
`
const TextDiv = styled.div`
  color: #4A4A4A;
  margin: 12px 0px 20px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    width: 368px;
  }
`

class InviteProvider extends Component {
  showInviteProviderInputView = () => {
    this.props.setInviteProviderInputView(true)
  }

  render() {
    return (
      <InviteProviderContainer paddingLeft='35px' paddingRight='60px'>
        <UserPlusIcon/>
        <TextButtonContainer>
          <TextContainer>
            <HeaderDiv>Invite Provider</HeaderDiv>
            <TextDiv>Want the transparency and control of a digitally-enabled title partner, but love your current title contact? Invite your provider and Qualia will reach out to them.</TextDiv>
          </TextContainer>
          <SettlementButton oldColorPalette={true} largerFont={true} primary
                            paddingTopBottom={10} paddingLeftRight={22.5}
                            onClick={this.showInviteProviderInputView}>Send invite</SettlementButton>
        </TextButtonContainer>
      </InviteProviderContainer>
    )
  }
}

const selector = createStructuredSelector({
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(InviteProvider)
